// extracted by mini-css-extract-plugin
export default {"Container":"links_Container__OGj8e","Status-active":"links_Status-active__5qM+y","Status-inactive":"links_Status-inactive__W4+0x","balance":"links_balance__qNj9B"};